// extracted by mini-css-extract-plugin
module.exports = {"likes-page":"liked_likes-page__n8UGf","liked-video-container":"liked_liked-video-container__1UejQ"};